<template>
  <a :href="file.fileUrl" target="_blank" class="file-preview">
    <div class="icon-container">
      <fa-icon v-if="fileExtension === 'pdf'" icon="file-pdf"/>
      <fa-icon v-else icon="image"/>
    </div>
    <div class="name-container">
      {{ file.fileName }}
    </div>

  </a>
</template>

<script>
  export default {
    name: "FilePreview",
    props: {
      file: {
        type: Object
      }
    },

    computed: {
      fileExtension() {
        return this.file.fileUrl.split('.').pop();
      }
    },


  }
</script>

<style scoped>

</style>
